import { filter, take } from 'lodash'
import { observable, action, computed } from 'mobx'

const countryOpts = require('../data/countries.json')
  .map(({code, name}) => {
    return {
      text: name,
      value: code,
      key: code,
      flag: code.toLowerCase(),
      name: name,
      code: code
    }
  })

const airFilter = query => {
  if (!query || query.length < 2) return take(countryOpts, 5)
  const regExp = new RegExp(`\\b${query}*`, 'gi');
  return filter(countryOpts, ({code, name}) => {
    return regExp.test(code) || regExp.test(name);
  })
}


class CountryAutocomplete {
  @observable passportOptions = []
  @action countrySuggest = (e) => {
    if (e.key === 'Enter') { return }
    this.passportOptions = airFilter(e.target.value)
  }
}

export default new CountryAutocomplete()



// WEBPACK FOOTER //
// ./src/stores/CountryAutocomplete.js